import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import Quarterly from "./Quarterly";
import Monthly from "./Monthly";
import Yearly from "./Yearly";
import "./SubscriptionPlans.css";
import aboutbanners from "../../assets/images/about-head-banner.jpg";
import { FaChevronRight } from "react-icons/fa";

const SubscriptionPlans = ({ onRequestProcessed }) => {
  const [selectedTab, setSelectedTab] = useState(1);
  const navigate = useNavigate();

  useEffect(() => {
    if (onRequestProcessed) {
      setSelectedTab(1);
    }
  }, [onRequestProcessed]);

  return (
    <div className="subscription-container">
      <div
        className="bannersec"
        style={{
          backgroundImage: `url(${aboutbanners})`,
        }}
      >
        <h4>Subscription Plans</h4>
        <p>
          Home{" "}
          <span>
            <FaChevronRight />
          </span>{" "}
          Subscription Plans
        </p>
      </div>
      <div className="containerall">
        <div className="subscription-header">
          <h2 className="subscription-title">Subscription Plans</h2>
        </div>
        <div className="tabs-container">
          <button
            className={`tab-button ${selectedTab === 1 ? "active" : ""}`}
            onClick={() => setSelectedTab(1)}
          >
            Monthly
          </button>
          <button
            className={`tab-button ${selectedTab === 0 ? "active" : ""}`}
            onClick={() => setSelectedTab(0)}
          >
            Quarterly
          </button>
          <button
            className={`tab-button ${selectedTab === 2 ? "active" : ""}`}
            onClick={() => setSelectedTab(2)}
          >
            Yearly
          </button>
        </div>

        <div className="tab-content">
          {selectedTab === 0 ? (
            <Quarterly />
          ) : selectedTab === 1 ? (
            <Monthly />
          ) : (
            <Yearly />
          )}
        </div>
      </div>
    </div>
  );
};

export default SubscriptionPlans;
